var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "catalog", tag: "section" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$t("catalog.title")) + " "),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "secondary" },
                  on: { click: _vm.exportJson }
                },
                [_vm._v(" Export JSON ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: { click: _vm.createItemDialog }
                },
                [_vm._v(" Add Module ")]
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        staticClass: "searchBox",
                        attrs: {
                          "append-icon": "mdi-magnify",
                          label: _vm.$t("global.search"),
                          "aria-label":
                            _vm.$t("global.text-field") +
                            " " +
                            _vm.$t("global.search") +
                            " " +
                            _vm.$t("catalog.title"),
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-data-table",
                        {
                          attrs: {
                            filterable: "",
                            headers: _vm.headers.map(function(x) {
                              return Object.assign({}, x, {
                                text: _vm.$t(x.text)
                              })
                            }),
                            items: _vm.items,
                            "item-key": "id",
                            loading: _vm.loading,
                            search: _vm.search,
                            "items-per-page": 30
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item.title",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _vm._v(" " + _vm._s(_vm.getTitle(item)) + " ")
                                ]
                              }
                            },
                            {
                              key: "item.actions",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        "aria-label":
                                                          _vm.$t(
                                                            "global.edit"
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "modules.moduleParam",
                                                            [item.id]
                                                          )
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.editItem(
                                                            item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      " mdi-pencil-outline "
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("edit")))
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        "aria-label":
                                                          _vm.$t(
                                                            "global.delete"
                                                          ) +
                                                          " " +
                                                          _vm.$t(
                                                            "modules.moduleParam",
                                                            [item.id]
                                                          )
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.deleteItem(
                                                            item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      " mdi-delete-outline "
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("delete")))
                                      ])
                                    ]
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.selected,
                            callback: function($$v) {
                              _vm.selected = $$v
                            },
                            expression: "selected"
                          }
                        },
                        [_vm._v('" ')]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "800px" },
              model: {
                value: _vm.showEditDialog,
                callback: function($$v) {
                  _vm.showEditDialog = $$v
                },
                expression: "showEditDialog"
              }
            },
            [
              _c("catalog-edit", {
                attrs: { moduleid: _vm.selectedItemID },
                on: { cancel: _vm.closeEditDialog, save: _vm.saveEditDialog }
              })
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.showConfirmDeleteDialog,
                callback: function($$v) {
                  _vm.showConfirmDeleteDialog = $$v
                },
                expression: "showConfirmDeleteDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(_vm._s(_vm.$t("global.confirm")))
                  ]),
                  _c("v-card-text", [
                    _vm._v(_vm._s(_vm.$t("catalog.confirm-delete")) + " "),
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.selectedItemID))
                    ]),
                    _vm._v("?")
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue" },
                          on: { click: _vm.cancelDelete }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.no")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "red" },
                          on: { click: _vm.confirmDelete }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.yes")) + " ")]
                      ),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }